export enum ImageRatio {
  Square = 1,
  Landscape = 1.5, // 3/2
}
